module.exports = new __parcel__URL__("Employee Handbook.fb183623.svg").toString();